import React from 'react';
import { useMemo } from 'react';
import { DrawApi } from '@apply/api';
import { ApprovedCheckbox } from './ApprovedCheckbox';
import { EquityMetOn } from './EquityMetOn';
import { EquityRequirement } from './EquityRequirement';
import { BankAccountLast4Digits } from './BankAccountLast4Digits';
import { isMobileScreen } from '../../../../helpers';

interface IHeaderPanelCenterProps {
    onEquityRequirementChange: (newValue: number) => void;
    onEquityMetOnChange: (newValue: Date) => void;
    onBankAccountLast4DigitsOnChange: (newValue: string) => void;
    onApprovalAdd: () => void;
    drawBudget?: DrawApi.IDrawBudget;
    isAdmin: boolean;
    anyAcquisitionAmount: boolean;
}

export const HeaderPanelCenter = ({
    onEquityRequirementChange,
    onEquityMetOnChange,
    onBankAccountLast4DigitsOnChange,
    onApprovalAdd,
    drawBudget,
    isAdmin,
    anyAcquisitionAmount,
}: IHeaderPanelCenterProps): JSX.Element => {
    const headerWidth = useMemo(() => {
        let width = 300;
        if (isAdmin) {
            width += 300;
        } else {
            if (anyAcquisitionAmount) {
                width += 100;
            }
        }
        return width;
    }, [isAdmin, anyAcquisitionAmount]);

    // Checking window width to apply mobile style
    const getStyle = () => {
        const mobileScreen = isMobileScreen();
        const style = mobileScreen ? { display: 'none' } : { width: headerWidth };
        return style;
    };

    return (
        <div
            className='draw-header-center draw-header-panel'
            style={getStyle()}
        >
            <div>
                <div className='draw-header-input-group'>
                    <h1 style={{ width: 300 }}>Budget</h1>
                    {isAdmin && (
                        <ApprovedCheckbox
                            drawBudget={drawBudget}
                            isAdmin={isAdmin}
                            onApprovalAdd={onApprovalAdd}
                        />
                    )}
                    <EquityRequirement
                        drawBudget={drawBudget}
                        isAdmin={isAdmin}
                        onEquityRequirementChange={onEquityRequirementChange}
                    />
                    <EquityMetOn
                        drawBudget={drawBudget}
                        isAdmin={isAdmin}
                        onEquityMetOnChange={onEquityMetOnChange}
                    />
                    {isAdmin && (
                        <div>
                            <label htmlFor='bankAccountLast4Digits'>Bank Account (Last 4 Digits)</label>
                            <BankAccountLast4Digits
                                id={'bankAccountLast4Digits'}
                                onChange={onBankAccountLast4DigitsOnChange}
                                value={drawBudget?.bankAccountLast4Digits}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
